import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lodash from "lodash";

import GroupItem from "./GroupItem";
import ModalEditCreate from "./ModalEditCreate";

const Header = () => (
  <thead>
    <tr>
      <th>Name</th>
      <th>Locations</th>
      <th />
    </tr>
  </thead>
);

class LocationGroup extends React.Component {
  state = {
    loading: true,
    groups: [],
    modalIsOpen: false,
    dataEdit: null
  };

  componentWillMount() {
    axios.get("/groups").then(resp => {
      this.setState({ groups: resp.data });
      this.setState({ loading: false });
    });
  }

  render() {
    const { locations } = this.props;
    const { loading, groups, modalIsOpen, dataEdit } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-xs-3"><b>Groups</b></div>
          <div className="col-xs-9">
            {locations.length > 0 ? (
              <div className="pull-right">
                <a href='javascript:void()' className="btn btn-text" onClick={this.handlerNewGroup}>
                  ADD GROUP
                </a>

                <ModalEditCreate
                  locations={locations}
                  visible={modalIsOpen}
                  dataEdit={dataEdit}
                  onClosed={this.handlerClosedModal}
                  onAction={this.handlerAction}
                />
              </div>
            ) : null}
          </div>
        </div>
        
        <p className="grey-text">
          Location Groups allow you to message employees at multiple locations 
          via the Messaging module. For example, you can group several locations
           in a region and send a message to all employees with any of those 
           locations as their primary location.
        </p>

        {loading || groups.length === 0 ? (
          <span>
            <br />
            <p className="grey-text">{loading ? "Loading..." : "No Groups"}</p>
          </span>
        ) : (
          <table className="table table-clean">
            <Header />
            <tbody>
              {groups.map(item => (
                <GroupItem
                  key={item.id}
                  data={item}
                  onAction={this.handlerAction}
                />
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }

  handlerNewGroup = () => this.setState({ dataEdit: null, modalIsOpen: true });

  handlerClosedModal = () =>
    this.setState({ dataEdit: null, modalIsOpen: false });

  handlerAction = data => {
    const tmp = this.state.groups;
    const idx = lodash.findIndex(tmp, { id: data.payload.id });

    switch (data.type) {
      case "deleted":
        if (idx !== -1) {
          tmp.splice(idx, 1);
          this.setState({ groups: tmp });
        }
        break;
      case "updated":
        if (idx !== -1) {
          tmp[idx] = data.payload;
          this.setState({ groups: tmp });
        }
        break;
      case "created":
        tmp.push(data.payload);
        this.setState({ groups: tmp });
        break;
      case "edit":
        this.setState({
          dataEdit: tmp[idx],
          modalIsOpen: true
        });
        break;
    }
  };
}

LocationGroup.propTypes = {
  locations: PropTypes.array.isRequired
};

export default LocationGroup;
